import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import ReusableButton from 'components/common/Button';
import Lottie from 'lottie-react';
import animationData from 'assets/Lottie/no_data.json';
import { useDispatch, useSelector } from 'react-redux';
import ToastNotification from 'components/common/Toast';
import { superAdminCreateCoupon } from 'routes/AppUrls';
import { getCouponListCallAPI } from 'store/SuperAdmin/getCoupon/action';
import SwitchInput from 'components/common/Input/SwitchInput';
import trash from 'assets/images/Dashboard/trash.png';
import EditUnderlineIcon from 'assets/images/Category/editUnderlineIcon.png';
import moment from 'moment';
import { ShimmerBox } from 'components/common/Shimmer';

const Coupons = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const [conf, setConf] = ToastNotification();
  const { locale } = useContext(LocaleContext);

  const getCouponListData = useSelector(
    (state) => state?.getCouponListReducer?.data?.data
  );
  const couponLoading = useSelector(
    (state) => state?.getCouponListReducer?.loading
  );
  const [couponData, setCouponData] = useState(
    getCouponListData ? getCouponListData : []
  );

  useEffect(() => {
    getCouponsList();
  }, []);

  const getCouponsList = () => {
    dispatch(
      getCouponListCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleCouponListSuccess(res),
          naviagte: navigate,
        }
      )
    );
  };

  const handleCouponListSuccess = (res) => {
    setCouponData(res?.data?.data);
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <div className="flex justify-between items-center">
          <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
            <FormattedMessage id="Coupons" />
          </h2>
          {!couponLoading && (
            <ReusableButton
              fullWidth={false}
              variant="contained"
              color="#F5F5F5"
              fontSize="16px"
              fontWeight="400"
              padding="12px 24px"
              height="48px"
              bgColor="#292D32"
              fontFamily="Akkurat"
              onClick={() => navigate(superAdminCreateCoupon(locale))}
            >
              <FormattedMessage id="Create Coupon" />
            </ReusableButton>
          )}
        </div>

        <Row className="mt-3 listHeader m-0 p-0 flex items-center">
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Coupon Name" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Coupon Code" />
            </p>
          </Col>
          <Col lg={3} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="StartDate Time" />
            </p>
          </Col>
          <Col lg={3} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="EndDate Time" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Status" />
            </p>
          </Col>
          {/*<Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold">
              <FormattedMessage id="Actions" />
            </p>
          </Col>*/}
        </Row>

        <Row className="bc-FFFFFF m-0 p-0">
          {couponLoading ? (
            <>
              {[1, 2, 3, 4, 5].map((item) => (
                <Row key={item} className="m-0 flex items-center listCampaign">
                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="150px" height="14px" />
                  </Col>

                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="120px" height="14px" />
                  </Col>

                  <Col lg={3} md={6} sm={12}>
                    <ShimmerBox width="100px" height="12px" />
                    <ShimmerBox width="80px" height="12px" className="mt-1" />
                  </Col>

                  <Col lg={3} md={6} sm={12}>
                    <ShimmerBox width="100px" height="12px" />
                    <ShimmerBox width="80px" height="12px" className="mt-1" />
                  </Col>

                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="70px" height="14px" />
                  </Col>
                </Row>
              ))}
            </>
          ) : couponData?.length > 0 ? (
            couponData.map((key, index) => (
              <Row className="m-0 flex items-center listCampaign">
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                    {key?.name}
                  </p>
                </Col>

                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                    {key?.code}
                  </p>
                </Col>

                <Col lg={3} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                    {moment(key?.start_datetime).format('DD MMM YYYY')}
                  </p>
                  <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                    {moment(key?.start_datetime).format('hh:mm A')}
                  </p>
                </Col>

                <Col lg={3} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                    {moment(key?.end_datetime).format('DD MMM YYYY')}
                  </p>
                  <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                    {moment(key?.end_datetime).format('hh:mm A')}
                  </p>
                </Col>

                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                    {key?.is_active ? 'Active' : 'Inactive'}
                  </p>
                  {/*<SwitchInput
                    label={true}
                    checked={key?.is_active}
                    // onChange={(e) => handleSwitchChange(e)}
                    color="secondary"
                  />*/}
                </Col>

                {/*<Col lg={2} md={6} sm={12}>
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center "
                  >
                    <img
                      className="cursor-pointer"
                      src={EditUnderlineIcon}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                      //   onClick={() => handleEditCampaign(key)}
                    />
                    <img
                      className="cursor-pointer"
                      src={trash}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                      //   onClick={() => handleDeleteCampaign(key)}
                    />
                  </Stack>
                </Col>*/}
              </Row>
            ))
          ) : (
            <Row className="bc-FFFFFF m-0 p-50 flex justify-center items-center">
              <Lottie
                animationData={animationData}
                loop={true}
                style={{ height: '200px', width: '200px' }}
              />
            </Row>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default Coupons;
